<template>
  <b-modal
    :id="id"
    v-model="$show"
    :title="title"
    :size="size"
    :centered="centered"
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
    :hide-header="hideHeader"
    :hide-footer="hideFooter"
    :modal-class="{ 'modal-fullscreen': isFullscreen }"
    :hide-backdrop="hideBackdrop"
    static
    scrollable
    @hidden="closeModal()"
    @show="openModal()"
  >
    <slot slot="modal-header" name="modal-header" />

    <!-- modal body -->
    <slot />

    <!-- modal footer | slot="modal-footer ใช้สำหรับส่งค่าไปใน b-modal อีกที" -->
    <slot slot="modal-footer" name="modal-footer" />
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  name: 'BaseModal',

  components: { BModal },

  props: {
    id: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        return ['sm', 'md', 'lg', 'xl'].indexOf(value) !== -1;
      }
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: true
    },
    noCloseOnEsc: {
      type: Boolean,
      default: true
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    isFullscreen: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: true
    },
    hideBackdrop: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal', true);
    },
    openModal() {
      this.$emit('openModal', true);
    }
  }
};
</script>

<style scoped>
::v-deep .modal-backdrop {
  background-color: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .modal-fullscreen .modal-dialog {
  max-width: 100% !important;
  margin: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 100% !important;
  display: flex !important;
  position: fixed !important;
}
</style>
